export interface Options {
    // enable to produce xxxx.d.ts file.
    // { null, 'module' }
    definition: string;

    // enable to produce xxxx.ts file.
    //  { null, 'module', 'interface' }
    typescript: string;

    // enable to produce xxxx.json file.
    json: boolean;

    // if set a space characters, it adds formating of JSON.
    // it set null, space will be eliminated.
    jsonSpace: string | number;
}

interface NameValuePair {
    name: string;
    value: any;
}

export class ResJsonConverter {
    private static openContent =
`/* eslint:disable */
/**
 * @file Source code generated by gulp-resjson.
 * @version 1.0
 */
`;
    private static closeContent =
`}
`;
    public outputJson: any;
    private outputDefinition: string[];
    private outputTypescript: string[];
    private outputInterface: string[];
    private jsonCurrent: any;
    private root: any;

    constructor(private options: Options) {
    }

    public get contentDefinition(): string {
        return this.outputDefinition.join('');
    }

    public get contentTypescript(): string {
        return this.outputTypescript.join('');
    }

    public get contentInterface(): string {
        return this.outputInterface.join('');
    }

    public contentReset(): void {
        this.outputDefinition = [];
        this.outputTypescript = [];
        this.outputInterface = [];
        this.outputJson = {};
        this.jsonCurrent = this.outputJson;
    }

    public convert(content: string, validate: boolean) {
        // Remove comments, /* multiline comment */ and // one line comment and "//": "JSON element comment"
        content = content.replace(/(\/\*([^*]|[\n]|(\*+([^*/]|[\n])))*\*\/+)|( +\/\/.*)|(  +\"\/\/\".*)/g, '');
        const data: any = JSON.parse(content);
        this.root = {};
        this.buildObject(data, validate);
        this.contentReset();
        this.traverse([{ name: 'Strings', value: this.root }], 0);
    }

    private buildObject(data: any, validate: boolean, indexes?: string[]): void {
        const itemKeys = Object.keys(data);
        for (const itemKey of itemKeys) {
            if (this.skipComment(itemKey, validate, itemKeys)) {
                continue;
            }

            if (!data.hasOwnProperty(itemKey)) {
                continue;
            }

            const itemValue = data[itemKey];
            if (typeof itemValue !== 'string') {
                // nested object, so scan inside to add to current.
                const newIndexes = indexes ? indexes.slice(0) : [];
                newIndexes.push(itemKey);
                this.buildObject(itemValue, validate, newIndexes);
                continue;
            }

            let current = this.root;
            const keys = indexes ? indexes.slice(0) : [];
            keys.push(...itemKey.split('_'));
            let count = keys.length;
            for (const key of keys) {
                count--;
                if (count > 0) {
                    if (!current.hasOwnProperty(key)) {
                        current[key] = {};
                    }

                    current = current[key];

                    if (typeof current !== 'object') {
                        throw new Error('Resource key already exists: ' + itemKey);
                    }
                } else {
                    current[key] = itemValue;
                }
            }
        }
    }

    private skipComment(itemKey: string, validate: boolean, itemKeys: string[]): boolean {
        // remove localization comments
        if (itemKey.startsWith('//')) {
            return true;
        } else if (itemKey.startsWith('_')) {
            if (validate) {
                if (!itemKey.endsWith('.comment')) {
                    throw new Error('Resource cannot start with underscore: ' + itemKey);
                }

                const found = itemKeys.find(item => itemKey === `_${item}.comment`);
                if (!found) {
                    throw new Error('Resource comment doesn\'t match: ' + itemKey);
                }
            }

            return true;
        }

        return false;
    }

    private jsonNewValue(name: string): any {
        const old = this.jsonCurrent;
        const json = {};
        this.jsonCurrent[name] = json;
        this.jsonCurrent = json;

        return old;
    }

    private jsonAddValue(name: string, value: any): void {
        this.jsonCurrent[name] = value;
    }

    private scan(node: any): { keyItems: NameValuePair[], dataItems: NameValuePair[] } {
        const current = node;
        const keyItems: NameValuePair[] = [];
        const dataItems: NameValuePair[] = [];
        for (const itemKey in current) {
            if (current.hasOwnProperty(itemKey)) {
                const itemValue: any = current[itemKey];
                if (typeof itemValue === 'object') {
                    keyItems.push({ name: itemKey, value: itemValue });
                } else if (typeof itemValue === 'string') {
                    dataItems.push({ name: itemKey, value: itemValue });
                }
            }
        }

        return {
            keyItems: keyItems,
            dataItems: dataItems
        };
    }

    private traverse(keyItems: NameValuePair[], indent: number): void {
        const indentSpace = '    ';
        let indentName = '';
        for (let i = 0; i < indent; i++) {
            indentName += indentSpace;
        }

        const indentValue: string = indentName + indentSpace;
        if (keyItems.length > 0) {
            for (const item of keyItems) {
                if (indent === 0) {
                    this.outputDefinition.push(ResJsonConverter.openContent);
                    this.outputTypescript.push(ResJsonConverter.openContent);
                    this.outputInterface.push(ResJsonConverter.openContent);
                    this.outputDefinition.push('export declare module ' + item.name + ' {\r\n');
                    this.outputTypescript.push('export module ' + item.name + ' {\r\n    \'use strict\';\r\n');
                    this.outputInterface.push('export interface ' + item.name + ' {\r\n');
                } else {
                    this.outputDefinition.push(indentName + 'module ' + item.name + ' {\r\n');
                    this.outputTypescript.push(indentName + 'export module ' + item.name + ' {\r\n');
                    this.outputInterface.push(indentName + item.name + ': {\r\n');
                }

                const jsonOld = this.jsonNewValue(item.name);
                const results = this.scan(item.value);
                for (const item2 of results.dataItems) {
                    this.outputDefinition.push(indentValue + 'const ' + item2.name + ': string;\r\n');
                    this.outputTypescript.push(indentValue + 'export const ' + item2.name + ' = \'' + item2.value + '\';\r\n');
                    this.outputInterface.push(indentValue + item2.name + ': string;\r\n');
                    this.jsonAddValue(item2.name, item2.value);
                }

                this.traverse(results.keyItems, ++indent);
                this.jsonCurrent = jsonOld;

                this.outputDefinition.push(indentName + '}\r\n');
                this.outputTypescript.push(indentName + '}\r\n');
                this.outputInterface.push(indentName + '};\r\n');
            }
        }
    }
}
